import { DEFAULT_DEGREE_IMAGES } from "./defaultDegreeImages";

export interface DegreeImageProps {
  imageurl: string;
  imagetitle: string;
  height: number;
  width: number;
  brandColor: string;
}

export const getDegreeImage = (
  uuid: string | null | undefined,
  section: "about" | "admissions",
): DegreeImageProps => {
  if (!uuid) {
    return {
      imageurl: "",
      imagetitle: "",
      height: 0,
      width: 0,
      brandColor: "",
    };
  }

  const degreeImages = DEFAULT_DEGREE_IMAGES[uuid];

  if (!degreeImages) {
    return {
      imageurl: "",
      imagetitle: "",
      height: 0,
      width: 0,
      brandColor: "",
    };
  }

  const image =
    section === "about"
      ? degreeImages.aboutImage
      : degreeImages.admissionsImage;

  return {
    imageurl: image?.url || "",
    imagetitle: image?.altText || "",
    height: image?.height || 0,
    width: image?.width || 0,
    brandColor: degreeImages.brandColor || "",
  };
};
